<p class="publication-subtitle sparro-grey-800">
  {{ publication.desc | truncate : 50 }}
</p>
